import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const DashboardSampleBanner = () => (
  <div className="dashboard-sample-banner" role="status">
    <InfoOutlinedIcon />
    <p>
      <strong>This is sample data.</strong>
      {' '}
      Here&apos;s what your dashboard will show once you start mailing - your real numbers will
      replace it.
    </p>
  </div>
);

export default DashboardSampleBanner;
